import { request } from '../methods'

// Turns out bordereau is the correct spelling but the api endpoints are misspelled
export default {
  listBordereau: request('get', '/api/v1/programs/{program_pk}/bordereaux/'),
  createBordereau: request('post', '/api/v1/programs/{program_pk}/bordereaux/'),
}
